import category from './category.reducer';
import product from './product.reducer';
import auth from './auth.reducer';
import cart from './cart.reducer';
import user from './user.reducer';
import filters from './filter.reducer';
import manufacture from './components/manufacture'
import comeToUs from './components/comeToUs'
import mainImage from './components/mainImage'
import promotion from './components/promotion'
import weWorkOnline from './components/weWorkOnline'
import contact from './components/contact'
import paymentLI from './components/paymentLI'
import costDelivery from './components/costDelivery'
import application from './application.reducer'
import blog from './components/blog'
import gallery from './components/gallery'
import portfolio from './components/portfolio'
import warranty from './components/warranty'
import deliveryInfo from './components/deliveryInfo'
import paymentList from './components/paymentList'
import aboutUs from './components/aboutUs'
import benefits from './components/benefits'
import architect from './components/architect'
import architectLi from './components/architectLi'
import architectSkills from './components/architectSkills'
import partner from './components/partner'
import material from './components/material'
import allQuestion from './components/allQuestion'
import desires from './desires'
import historyProduct from './historyProduct'
import order from './order.reducer'
import pickupPoints from './components/pickupPoints'
import region from './components/region'
import contactM from './components/contactM'
import elementPaymentPage from './components/elementPaymentPage'
import roleChangeRequest from './roleChangeRequest'
import applicationCallMe from './applicationCallMe'
import applicationChangeProfile from './applicationChangeProfile'
import mainPage from './mainPage'
import applicationGallery from './applicationGallery'
import galleryImgUser from './galleryImgUser'
import productListLink from './productListLink'
import partnerProfile from './partnerProfile'
import scene from './sceneReducer'
import office from './office'
import officeOwner from './officeOwner'
import printForm from './printForm'
import chat from './chatReducer'
import message from './messageReducer'
import paymentOrder from './paymentOrder'
import notification from './notificationReducer'
import inventoryReducer from './inventory.reducer';
import productOffice from './productOffice.reducer';
import officeCategory from './officeCategory.reducer';
import manualOrder from './manualOrder.reducer';
import officePrice from './officePrice.reducer';
import measureReducer from './measureReducer';
import officeAnalyticsReducer from "./officeAnalytics.reducer";
import billingReducer from "./billing.reducer";
import officeMember from "./officeMember.reducer";
import officeInvite from "./officeInvite.reducer";
import officeSalesSession from "./officeSalesSession.reducer";
import accountProfileReducer from "./accountProfile.reducer";
import mailingReducer from "./mailing.reducer";
import publicFeaturedProductItem from "./publicFeaturedProductItem.reducer";
import operationType from './operationType.reducer'
import productOperationTemplate from './productOperationTemplate.reducer'
import productionTariff from './productionTariff.reducer'
import officeProductOffer from './officeProductOffer.reducer'
import officeProductOperationPrice from './officeProductOperationPrice.reducer'
import calc3dUi from './calc3dUi.reducer'
import officeOrderReducer from "./officeOrder.reducer";
import officeTaskReducer from "./officeTask.reducer";
import officeTaskCreateModal from "./officeTaskCreateModal.reducer";
import officePaymentAccount from "./officePaymentAccount.reducer";
import officeOrderModal from "./officeOrderModal.reducer";
import officeEntityModal from "./officeEntityModal.reducer";
import officeProductGallery from "./officeProductGallery.reducer";
import officeProduct3D from "./officeProduct3D.reducer";
import officeOrderFinanceAnalytics from "./officeOrderFinanceAnalytics.reducer";
import accessGate from "./accessGate.reducer";

import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    accessGate,
    officeOrderFinanceAnalytics,
    officeOrderModal,
    officeEntityModal,
    officeProductGallery,
    officeProduct3D,
    officePaymentAccount,
    officeTaskCreateModal,
    officeTask: officeTaskReducer,
    officeOrder: officeOrderReducer,
    calc3dUi,
    publicFeaturedProductItem,
    accountProfile: accountProfileReducer,
    mailing: mailingReducer,
    billing: billingReducer,
    officeAnalytics: officeAnalyticsReducer,
    measure: measureReducer,
    officePrice,
    operationType,
    productOperationTemplate,
    productionTariff,
    officeProductOffer,
    officeProductOperationPrice,
    manualOrder,
    officeCategory,
    productOffice,
    inventory: inventoryReducer,
    category,
    blog,
    portfolio,
    product,
    auth,
    cart,
    user,
    filters,
    manufacture,
    comeToUs,
    mainImage,
    promotion,
    weWorkOnline,
    contact,
    paymentLI,
    costDelivery,
    gallery,
    application,
    deliveryInfo,
    warranty,
    benefits,
    paymentList,
    aboutUs,
    architect,
    architectLi,
    architectSkills,
    partner,
    material,
    allQuestion,
    desires,
    historyProduct,
    pickupPoints,
    order,
    region,
    roleChangeRequest,
    contactM,
    elementPaymentPage,
    applicationCallMe,
    mainPage,
    applicationChangeProfile,
    applicationGallery,
    galleryImgUser,
    productListLink,
    partnerProfile,
    scene,
    officeOwner,
    office,
    officeMember,
    officeSalesSession,
    printForm,
    message,
    chat,
    paymentOrder,
    notification,
    officeInvite,
});

export default rootReducer;
